import { getNumberValueSeparatedByCommas } from '@/Utils/utils';
import { generatePathForNode } from '@/helpers/spreadsheetHelper';
import '@/pages/SpreadsheetPage/index.scss';
import CustomGroupMenu from './CustomGroupMenu';

const CustomAutoGroupValue = ({ data: { groupCount }, value, node }) => {
  if ((value === null || value === undefined || value === '') && !groupCount) {
    return null;
  }

  const path = generatePathForNode(node);
  const { field } = node;
  const isNonEmptyString = typeof value === 'string' && value.trim().length > 0;
  const isNumberOrBoolean =
    (typeof value === 'number' && !isNaN(value)) || typeof value === 'boolean';

  const displayValue = isNonEmptyString || isNumberOrBoolean ? value : '(blank)';

  return (
    <div className='autoGroupColumn'>
      <span className='autoGroupColumn-group-value text-ui'>{displayValue}</span>
      {typeof groupCount === 'number' && (
        <span className='autoGroupColumn-group-count'>
          ({getNumberValueSeparatedByCommas(groupCount)})
        </span>
      )}
      <CustomGroupMenu node={node} field={field} path={path} />
    </div>
  );
};

export default CustomAutoGroupValue;
